import { render, staticRenderFns } from "./VeicoloStoricoSelect.vue?vue&type=template&id=3568905c&scoped=true"
import script from "./VeicoloStoricoSelect.vue?vue&type=script&lang=js"
export * from "./VeicoloStoricoSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3568905c",
  null
  
)

export default component.exports